import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { ViewerTopFragmentCommonProps } from "../viewer-top-fragment/ViewerTopFragment";
import TopFragmentWrapper from "../../../SheetTop/TopFragmentWrapper/TopFragmentWrapper";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import TitledHeadingText from "@coworker/apprestructured/src/task-management/components/TitledHeadingText/TitledHeadingText";
import styles from "./TitledHeadingTextViewerTopFragment.module.css";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { useTranslation } from "@coworker/locales";

export type TitledHeadingTextViewerTopFragmentConfigProps = {
  title: string;
  field: string;
};

type TitledHeadingTextViewerTopFragmentProps = {
  configProps: TitledHeadingTextViewerTopFragmentConfigProps;
  commonProps: ViewerTopFragmentCommonProps;
};

function TitledHeadingTextViewerTopFragment({
  configProps,
  commonProps,
}: TitledHeadingTextViewerTopFragmentProps) {
  const { title, field } = configProps;
  const { task } = commonProps;
  const text = getTypedValue<string>(getByPath(task, field));
  const state = getTypedValue<TaskState>(getByPath(task, "state"));

  const { t } = useTranslation();

  if (!text || isLoading(text)) {
    return null;
  }

  return (
    <TopFragmentWrapper state={state}>
      <div className={styles["card"]}>
        <TitledHeadingText label={t(title)} text={text} />
      </div>
    </TopFragmentWrapper>
  );
}

export default TitledHeadingTextViewerTopFragment;
